import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus, { ElCascader, ElDatePicker, ElInput, ElInputNumber, ElSelect, ElTimePicker, ElTreeSelect } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import 'virtual:uno.css'
import './style.css'

// 全局修改 Element Plus 组件的默认 placeholder
function setGlobalPlaceholder(component: any, placeholder: string) {
  if (!component || !component.props) return
  const prop = component.props.placeholder
  if (prop) {
    if (typeof prop === 'object') {
      prop.default = placeholder
    } else {
      component.props.placeholder = { type: prop, default: placeholder }
    }
  }
}

setGlobalPlaceholder(ElInput, '请输入')
setGlobalPlaceholder(ElInputNumber, '请输入')
setGlobalPlaceholder(ElSelect, '请选择')
setGlobalPlaceholder(ElTreeSelect, '请选择')
setGlobalPlaceholder(ElCascader, '请选择')
setGlobalPlaceholder(ElDatePicker, '请选择')
setGlobalPlaceholder(ElTimePicker, '请选择')

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn
  // size: 'large'
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) app.component(key, component)
app.mount('#app')
